import { Component, Inject } from "@angular/core";
import { ItemsList } from "@ng-select/ng-select/lib/items-list";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
    selector: 'app-change-owner-dialog',
    templateUrl: './change-owner.component.html',
    styleUrls: ['./change-owner.component.scss']
  })
export class ChangeOwnerDialogComponent {
  selectedIds = [];
  noOwner;
  constructor(public dialogRef: MatDialogRef<ChangeOwnerDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
      this.dialogRef.disableClose = true;
      // const approvers = data.allDetails.approvers.map(app => app._id);
      // const endosers = data.allDetails.endorsers.map(end => end._id);
      // this.selectedIds = [...this.selectedIds, ...approvers, ...endosers];
      console.log(this.selectedIds);
  }
  changeUser;

  setTaskOwner(event) {
    console.log(event);
    if (event.selectedItems.length > 0) {
      this.changeUser = event.selectedItems[0];
      this.noOwner = false;
    }
  }

  removedOwner(event) {
    this.changeUser = undefined;
    this.noOwner = true;
  }

  submit() {
    if(this.changeUser){
      this.dialogRef.close(this.changeUser);
    }else{
      this.noOwner = true;
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}


